/**
 * Shared dashboard apiClient configuration for the Booking app.
 *
 * Extracted from `main.tsx` (Phase 6b Layer-2 adoption,
 * agents/plans/response_shape_fleet_rollout_plan_2026-06-09.md): the
 * X-Tenant-Id REQUEST interceptor below mutates outbound headers only — it is
 * not a response-validation site — so it belongs in the API layer next to the
 * fetch-boundary guards (schemas.ts) rather than in the React entry point.
 */

import { apiClient } from "@plerity/dashboard-shared/hooks";
import { useAdminStore } from "../../../lib/admin";

/**
 * Register the X-Tenant-Id request interceptor on the shared dashboard
 * apiClient.
 *
 * The dashboard-shared hooks (useApiQuery, usePaginatedQuery) use their own
 * internal apiClient which doesn't know about the Booking app's admin org
 * switcher. Without this interceptor, switching orgs in the dropdown only
 * affects mutations (which use the Booking app's local client) — queries
 * continue to fetch data for the default org resolved from hostname.
 *
 * Call once at app bootstrap (from main.tsx) before the first render.
 */
export function registerBookingApiInterceptors(): void {
  apiClient.interceptors.request.use((config) => {
    const selectedOrgId = useAdminStore.getState().selectedOrgId;
    if (selectedOrgId !== null) {
      config.headers.set("X-Tenant-Id", String(selectedOrgId));
    }
    return config;
  });
}
